import React from "react"
import { FC } from "react"

import { LeftOutlined } from "@ant-design/icons"
import { Card, Descriptions, Empty, Flex, Skeleton, Space } from "antd"
import { useNavigate, useParams } from "react-router-dom"

import classes from "@/_styles/cardById.module.scss"
import variables from "@/_styles/variables.module.scss"
import { ColorifiedButton } from "@/components/_Shared/Button/ColorifiedButton"
import { CustomersByClientTable } from "@/components/Customers/CustomersByClientTable"
import { Resource, Scope } from "@/constants/permission"

import { useCustomerClientByIdQuery } from "@/hook/CustomerClients/useCustomerClientQuery"
import { usePermission } from "@/hook/usePermission"

import { paths } from "@/router/paths"


const { Item } = Descriptions

const CustomerClientById: FC = () => {
  const navigate = useNavigate()
  const { id } = useParams<{ id?: string }>()

  const { data, isLoading, isError } = useCustomerClientByIdQuery(Number(id))
  
  const { hasPermission } = usePermission()
  const hasPermissionToCustomersTable = hasPermission(Resource.CustomerByClient, Scope.Read)
  const hasPermissionToCustomerClientsList = hasPermission(Resource.Customer, Scope.Menu)
  
  const onBackHandler = () => {
    navigate(-1)
  }

  const onBackToListHandler = () => {
    navigate(paths.customerClients)
  }

  if (isError) {
    return <Empty description="Клиент не найден" />
  }


  return (
    <Skeleton loading={isLoading}>
      {data && (
        <>
          <Card className={classes["card"]}>
            <Space direction="vertical" className={classes["wrapper"]}>
              <Descriptions
                title={
                  <div className={classes["header"]}>
                    <Flex align="center" gap="20px">
                      <ColorifiedButton 
                        themecolor="blue"
                        type="primary"
                        shape="circle"
                        size="small"
                        icon={<LeftOutlined />}
                        onClick={onBackHandler}
                      />
                      <span>{data.response.name}</span>
                    </Flex>
                  </div>                 
                }
                layout="vertical"
                column={3}
                className={classes["descriptions"]}
                labelStyle={{ 
                  fontWeight: 600, 
                  color: variables.tableSubTitleColor, 
                  marginBottom: "-30px"
                }}
                contentStyle={{
                  paddingBottom: "15px"
                }}
              >
                <Item label="Категория">{data.response.customerCategory.name}</Item>
                <Item label="ФИО ответственного лица">{data.response.managerName}</Item>
                <Item label="Номер телефона">+7 {data.response.phone}</Item>
              </Descriptions>
            </Space>
          </Card>

          {hasPermissionToCustomersTable && 
            <Space direction="vertical" className={classes["wrapper"]}>
              <CustomersByClientTable clientId={Number(id)}></CustomersByClientTable>
            </Space>
          }
        </>
      )}
    </Skeleton>
  )
}

export default CustomerClientById